import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import throttle from 'lodash/throttle';
import startCase from 'lodash/startCase';
import API from '../create/api';
import * as helper from '../../helper/index';

export default function Rider({ onChange, defaultValue = null, disabled = false }: any) {
  const [loading, setLoading] = React.useState(false);
  const [options, setOptions]: any = React.useState([]);
  const [inputValue, setInputValue] = React.useState('');
  const [value, setValue] = React.useState(defaultValue);

  // Add effect to sync with defaultValue changes
  React.useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const fetch = React.useMemo(() => {
    setLoading(true);
    return throttle(async (inputValue) => {
      await API.getAll(`${process.env.REACT_APP_API_SERVER}/riders?name_contains=${inputValue}&_limit=50`)
        .then((res: any) => {
          const riders = res
            .filter((c: any) => c?.user?.confirmed)
            .sort((a: any, b: any) => {
              const nameA = a.name.toUpperCase().trim();
              const nameB = b.name.toUpperCase().trim();
              if (nameA < nameB) return -1;
              if (nameA > nameB) return 1;
              return 0;
            })
            .map((c: any) => {
              return {
                label: `${c.id}: ${startCase(c.name.trim())}`,
                value: c.id,
              };
            });

          setOptions(riders);
        })
        .catch((e) => {
          helper.axiosErrorHandling(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 200);
  }, []);

  React.useEffect(() => {
    fetch(inputValue);
  }, [inputValue, fetch]);

  return (
    <Autocomplete
      disabled={disabled ?? loading}
      value={value}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      getOptionLabel={(option: any) => option?.label ?? ''}
      options={options}
      loading={loading}
      onChange={(e, newValue) => {
        setValue(newValue);
        onChange(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          fullWidth
          label="Rider Name"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
